import React from 'react';
// Zoho Creator "Multi Line" fields cap at 65,535 characters.
// "Large Text" / "Notes" fields can hold much more.
const DEFAULT_SOFT_LIMIT = 65535;
interface CodeEditorProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  language?: 'html' | 'css' | 'javascript';
  description?: string;
  /** Show a character counter. Pass a number to set a custom soft limit, or true for the default (65,535). */
  charLimit?: number | boolean;
}
export function CodeEditor({
  label,
  language = 'html',
  description,
  className = '',
  charLimit,
  ...props
}: CodeEditorProps) {
  const value = typeof props.value === 'string' ? props.value : '';
  const charCount = value.length;
  const softLimit = charLimit === true ? DEFAULT_SOFT_LIMIT : typeof charLimit === 'number' ? charLimit : 0;
  const showCounter = !!charLimit;
  const isNearLimit = softLimit > 0 && charCount > softLimit * 0.9;
  const isOverLimit = softLimit > 0 && charCount > softLimit;
  return <div className="space-y-2" data-id="element-1542" data-mp="2hzv4z8rbvop7">
      <div className="flex justify-between items-baseline" data-id="element-1543" data-mp="2hzmoz7zws39s">
        <label className="block text-sm font-medium text-gray-900" data-id="element-1544" data-mp="2my6chcu5hn49">
          {label}
        </label>
        <div className="flex items-center gap-3" data-id="element-1545" data-mp="28x3r72azcgue">
          {showCounter && <span className={`text-xs font-mono tabular-nums ${isOverLimit ? 'text-red-600 font-medium' : isNearLimit ? 'text-amber-600' : 'text-gray-400'}`} data-id="element-1546" data-mp="2cz7eqpaxbbw1">
              {charCount.toLocaleString()}
              {softLimit > 0 && ` / ${softLimit.toLocaleString()}`}
            </span>}
          <span className="text-xs text-gray-500 font-mono uppercase" data-id="element-1547" data-mp="1pbh5eoklckbj">
            {language}
          </span>
        </div>
      </div>
      {description && <p className="text-sm text-gray-500" data-id="element-1548" data-mp="1g9hmfqq0n65y">{description}</p>}
      {isOverLimit && <div className="flex items-start gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-md" data-id="element-1549" data-mp="1gbu402rv3eih">
          <span className="text-red-500 text-sm leading-none mt-0.5" data-id="element-1550" data-mp="1ladpy36ggqau">⚠</span>
          <p className="text-xs text-red-700" data-id="element-1551" data-mp="3mz1infbmmhuq">
            Content exceeds {softLimit.toLocaleString()} characters (
            {(charCount - softLimit).toLocaleString()} over). Zoho Creator may
            truncate when saving. Consider shortening or removing embedded
            images (use hosted URLs instead).
          </p>
        </div>}
      <div className="relative rounded-md shadow-sm" data-id="element-1552" data-mp="9rqaj315wi5d">
        <textarea className={`block w-full rounded-md border-gray-300 font-mono text-sm focus:border-blue-500 focus:ring-blue-500 bg-slate-50 min-h-[200px] p-4 ${isOverLimit ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} spellCheck={false} {...props} data-id="element-1553" data-mp="9p43r5m3i6o7" />
      </div>
    </div>;
}